import styled from '@emotion/styled';
import { theme, media } from '@vfit/shared/themes';
import { ICSSProps } from './textAreaInput.model';

export const ErrorMessage = styled.p`
  position: absolute;
  animation: fadein 2s;
  color: ${theme.colors.brand.primary};
  font-size: ${theme.typography.fontSize.body3};
  line-height: 0;
  font-family: ${theme.typography.fontFamily.secondary};
  font-weight: ${theme.typography.fontWeight.regular};
  text-align: left;
  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

export const Fieldset = styled.div<ICSSProps>`
  position: relative;
  margin: 0;
  margin-top: 9.008px;
  padding: 18px 16px 18px 20px;
  display: flex;
  transition: border 2s;
  border-radius: 5.008px;
  background: transparent;
  ${(props) => {
    if (props.error) {
      return `border: 1.008px solid ${theme.colors.brand.primary}`;
    }
    return props.isDisabled ? `border: 1.008px solid ${theme.colors.border.default}` : `border: 1.008px solid ${theme.colors.border.default}`;
  }};

  .wrapper {
    display: inline-flex;
    width: 100%;
    margin: 0;
    padding: 0;
  }

  .wrapper-icon {
    display: flex;
    align-self: center;
    ${media.tablet`
      align-self: center;
    `}
  }

  .icon {
    margin: auto;
    display: flex;
    flex-direction: column;
    appearance: none;
    background: none;
    border: none;
    font-family: inherit;
    font-size: inherit;
    padding: 0;

    &:hover {
      cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
    }
  }

  ${(props) => (props.isDisabled ? '&:hover {cursor: not-allowed}' : '')}
`;

// div for inputs
export const Field = styled.textarea<ICSSProps>`
  resize: none;
  height: 25.008px;
  margin: auto;
  width: 100%;
  outline: 0;
  border: 0;
  text-overflow: ellipsis;
  font-size: ${theme.typography.fontSize.body1};
  line-height: ${theme.typography.lineHeight.body2};
  text-align: left;

  &:disabled {
    background-color: transparent;
    cursor: not-allowed;
  }

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: ${theme.colors.text.primary};
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    box-shadow: 0 0 0 30px white inset !important;
  }

  ${media.tablet`
    margin: auto;
    height: 28px;
  `}
`;

export const Legend = styled.label<ICSSProps>`
  ${(props) => (props.error ? `color: ${theme.colors.brand.primary};` : `color: ${theme.colors.text.secondary}`)};
  height: 18px;
  padding: 0 ${theme.spacing.sm};
  margin-left: -5.008px;
  margin-top: 3.008px;
  transition: 0.2s;
  background: white;
  font-size: ${theme.typography.fontSize.body1};
  line-height: ${theme.typography.lineHeight.body2};
  font-family: ${theme.typography.fontFamily.secondary};
  font-weight: ${theme.typography.fontWeight.regular};
  text-align: left;
  position: absolute;

  textarea:not(:placeholder-shown) ~ &,
  textarea:focus ~ & {
    transition: 0.2s;
    top: -13.008px;
    font-size: ${theme.typography.fontSize.body3};
    line-height: ${theme.typography.lineHeight.body3};
    z-index: 2;
    color: ${theme.colors.text.primary};
  }
`;

